/**
 * @description
 * Objeto ListaCapacidadRepresenta
 */

import { CapacidadRepresenta } from "./capacidadrepresenta.models";

export class ListaCapacidadRepresenta {
    public capacidadRepresenta: CapacidadRepresenta[] = new Array<CapacidadRepresenta>();
  
    constructor() {}
}